module.exports = __webpack_public_path__ + "img/mercado.ffb20f78.png";